// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"86c555dcd1dc0bdf87c1b316503c2583a9f5b803"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "14.2.32";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: 'https://ef3bbd5e199ea13ae644596e3ece0834@o370725.ingest.us.sentry.io/4507024608722944',

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || 'local',
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
